export enum BannerType {
  QUOTA = 'quota',
}
